import { render, staticRenderFns } from "./drawlotterycarddetail.vue?vue&type=template&id=5d1c99b6&scoped=true"
import script from "./drawlotterycarddetail.vue?vue&type=script&lang=js"
export * from "./drawlotterycarddetail.vue?vue&type=script&lang=js"
import style0 from "./drawlotterycarddetail.vue?vue&type=style&index=0&id=5d1c99b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1c99b6",
  null
  
)

export default component.exports